import axios from "axios";
import { toast } from "react-toastify";
import store from "../store";
import {
  CH_MPCZ_AES_KEY,
  MSEDCL_BOT_HOST_URL,
  MSEDCL_HOST_URL,
  MSEDCL_UPDATE_SESSION_AUTH_TOKEN,
  MPCZ_HOST_URL,
  REACT_APP_AES_KEY_MSEDCL,
} from "../utills/constants";
import { AesECBDecrypt, AesECBDecryptt, AesECBEncrypt } from "../utills/encryption";

const axiosInstance = axios.create({});

const isMsedclUrl = (url) =>
  Boolean(
    url &&
      ((MSEDCL_HOST_URL && url.startsWith(MSEDCL_HOST_URL)) ||
        (MSEDCL_BOT_HOST_URL && url.startsWith(MSEDCL_BOT_HOST_URL)))
  );

const isMpczUrl = (url) => Boolean(url && MPCZ_HOST_URL && url.startsWith(MPCZ_HOST_URL));

const isBinaryResponse = (responseType) => ["blob", "arraybuffer"].includes(responseType);

const decryptEncryptedData = (data, key) => {
  if (typeof data !== "string" || !data.trim()) return data;

  try {
    const decrypted = AesECBDecrypt(key, data);
    return decrypted === "" || decrypted == null ? data : decrypted;
  } catch {
    return data;
  }
};

axiosInstance.interceptors.request.use((config) => {
  const isUpdateSessionVariable = config.url?.includes("update-session-variable");
  const isMsedclRequest = isMsedclUrl(config.url);
  const isMpczRequest = isMpczUrl(config.url);

  if (isUpdateSessionVariable) {
    config.headers["Content-Type"] = "application/json";
    config.headers["Authorization"] = `Bearer ${MSEDCL_UPDATE_SESSION_AUTH_TOKEN}`;
  } else {
    const state = store.getState().culturalHeritageReducer?.checksum;
    if (state) {
      if (state.merchantCode === "msedcl" || state.timeStamp === "mseemp" || state.timeStamp === "msedcl" || state.merchantCode === "MPCZ") {
        if (config.data instanceof FormData) {
          delete config.headers["Content-Type"];
        } else {
          config.headers["Content-Type"] = "application/json";
        }
      } else {
        config.headers["Content-Type"] = "text/plain";
      }
      config.headers["Whatsapp-Account"] = state.whatsappAccount;
      config.headers["Registered-Mobile-Number"] =state.whatsappAccount;
      config.headers["Registered-Mobile-Number-emp"] = "9871039335";
      config.headers["Accept-Language"] = state.acceptLanguage;
      config.headers["Authorization"] = `Bearer ${state.token}`;
    }
  }

  const encryptionKey = isMsedclRequest
    ? REACT_APP_AES_KEY_MSEDCL
    : isMpczRequest
      ? CH_MPCZ_AES_KEY
      : null;

  if (
    encryptionKey &&
    config.data != null &&
    !(typeof FormData !== "undefined" && config.data instanceof FormData) &&
    !(typeof Blob !== "undefined" && config.data instanceof Blob) &&
    !(typeof ArrayBuffer !== "undefined" && config.data instanceof ArrayBuffer)
  ) {
    config.data = AesECBEncrypt(encryptionKey, config.data);
    config.headers["Content-Type"] = "application/json";
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const isMsedclResponse = isMsedclUrl(response.config?.url);
    const isMpczResponse = isMpczUrl(response.config?.url);

    if (isMsedclResponse && !isBinaryResponse(response.config?.responseType)) {
      response.data = decryptEncryptedData(response.data, REACT_APP_AES_KEY_MSEDCL);
    } else if (isMpczResponse && !isBinaryResponse(response.config?.responseType)) {
      response.data = decryptEncryptedData(response.data, CH_MPCZ_AES_KEY);
    }

    return response;
  },
  (error) => {
    const isMsedclResponse = isMsedclUrl(error.response?.config?.url);
    const isMpczResponse = isMpczUrl(error.response?.config?.url);

    if (isMsedclResponse && !isBinaryResponse(error.response?.config?.responseType)) {
      error.response.data = decryptEncryptedData(error.response.data, REACT_APP_AES_KEY_MSEDCL);
    } else if (isMpczResponse && !isBinaryResponse(error.response?.config?.responseType)) {
      error.response.data = decryptEncryptedData(error.response.data, CH_MPCZ_AES_KEY);
    }

    if (error.response?.status === 500) {
      toast.error("Something went wrong", { position: "top-right", autoClose: 3000 });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
